import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LocalStorageManager } from "@/utils/LocalStorageManager";

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard = ({ children }: AuthGuardProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    const isAuthenticated = LocalStorageManager.loggedIn();
    const isAuthPage = location.pathname === "/";
    
    if (!isAuthenticated && !isAuthPage) {
      navigate("/");
    } else if (isAuthenticated && isAuthPage) {
      navigate("/voice-record");
    }
  }, [navigate, location.pathname]);
  
  return <>{children}</>;
};

export default AuthGuard;
